function getProductos(){
    return window.axios.get('/api/producto/index');
}
// function postAlmacen(data){
//     return window.axios.post('/api/almacen/create',data);
// }

export default {
    getProductos
}